/* global $:true */
//import 'babel-polyfill';

import debug from "debug";
import { PLUGIN_NAME, MODULE_NAME } from './index';
import { collectElementOptions} from '../../lib/objects';

const log = debug(MODULE_NAME);
const SECOND_ELEMENT_SELECTOR = '[data-coundown-timer-second]';
const MINUTE_ELEMENT_SELECTOR = '[data-coundown-timer-minute]';
const HOUR_ELEMENT_SELECTOR = '[data-coundown-timer-hour]';
const DAY_ELEMENT_SELECTOR = '[data-coundown-timer-day]';

const SECOND = 1000;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export class CountdownTimer {

	constructor(element, options) {
		this.element = element;
        this.$element = $(element);
		this.options = options;

		log(collectElementOptions(PLUGIN_NAME, this.$element.data()));

		// end-date required to be in the format
		// yyyy-MM-ddTHH:mm:ssZ
		this.end = new Date(this.options.endDate);
		this.timeReached = false;

		// start ticking
		this.timer = setInterval(this.onTick.bind(this), 1000);
		// do the first tick now
		this.onTick();
	}

	onEndReached() {
		clearInterval(this.timer);
		this.timeReached = true;
		this.render();
	}

	onTick() {
		const now = new Date();
		const distance = this.end - now;
		if (distance < 0) {
			this.onEndReached();
			return;
		}

		const days = Math.floor(distance / DAY);
		const hours = Math.floor((distance % DAY) / HOUR);
		const minutes = Math.floor((distance % HOUR) / MINUTE);
		const seconds = Math.floor((distance % MINUTE) / SECOND);

		this.render(days, hours, minutes, seconds);
	}

	render(days, hours, minutes, seconds) {
		// render the time reached message if time has been reached
		if(this.timeReached) {
			$(this.options.timeReachedSelector).removeAttr('hidden');
			// hide the countdown element
			this.$element.attr('hidden','');
			return;
		}

		const dayStr = ''+days;
		// pad the time values with 0s
		const hourStr = hours < 10 ? '0' + hours : ''+hours;
		const minuteStr = minutes < 10 ? '0' + minutes : ''+minutes;
		const secondStr = seconds < 10 ? '0' + seconds : ''+seconds;

		this.$element.find(DAY_ELEMENT_SELECTOR).text(dayStr);
		this.$element.find(HOUR_ELEMENT_SELECTOR).text(hourStr);
		this.$element.find(MINUTE_ELEMENT_SELECTOR).text(minuteStr);
		this.$element.find(SECOND_ELEMENT_SELECTOR).text(secondStr);
	}
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/countdown-timer/component.js